import { useEffect, useState } from "react";
import { getLoggedinUser } from "../../helpers/api_helper";

const useProfile = () => {

  const userProfileSession = getLoggedinUser();
  var token =localStorage.getItem('accessToken')
    const [loading, setLoading] = useState(userProfileSession ? false : true);
  const [userProfile, setUserProfile] = useState(
    userProfileSession ? userProfileSession : null
  );
  const [onBoardingPageCompletion , setOnBoardingPageCompletion] = useState(localStorage.getItem('onBoardingPageCompletion'))

  useEffect(() => {
    const userProfileSession = getLoggedinUser();
    var token =localStorage.getItem('accessToken')
    setUserProfile(userProfileSession ? userProfileSession : null);
    setLoading(token ? false : true);
  }, []);


  return { userProfile, loading, token , onBoardingPageCompletion };
};

export { useProfile };